import React from "react";
import Features from "../../components/base/landing/features";
import FooterLanding from "../../components/base/landing/footer";
import Hero from "../../components/base/landing/hero";
import Testimonials from "../../components/base/landing//testimonials";
import Navbar from "../../components/base/landing/navbar";
import WebAnalysis from "../../components/base/landing/webanalisys";
import Elegirnos from "../../components/base/landing/elegirnos";
import WhatsApp from "../../components/base/whatsapp";
import BlogButton from "../../components/base/blog";
import Nosotros from "../../components/base/landing/nosotros";
const LandingPage = () => {
  return (
    <>
      <Navbar />
      <Hero />
      <WebAnalysis />
      <Features />
      <Elegirnos />
      <Nosotros />
      <FooterLanding />
      <BlogButton/>
      <WhatsApp/>
    </>
  );
};

export default LandingPage;
